<h2 mat-dialog-title>Subject Profile</h2>

<mat-dialog-content class="dialog-content">
  <div *ngIf="isLoading" class="loading-state">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Loading profile...</p>
  </div>

  <div *ngIf="!isLoading" class="profile-wrap">
    <div class="summary-grid">
      <div><span class="label">Full name</span><span class="value">{{ getFullName() }}</span></div>
      <div><span class="label">ID number</span><span class="value">{{ response?.profile?.idNumber || 'N/A' }}</span></div>
      <div><span class="label">Birth date</span><span class="value">{{ response?.profile?.birthDate || 'N/A' }}</span></div>
      <div><span class="label">Gender</span><span class="value">{{ response?.profile?.gender || 'N/A' }}</span></div>
      <div><span class="label">Enquiry date</span><span class="value">{{ response?.profile?.enquiryDate || 'N/A' }}</span></div>
      <div><span class="label">Updated</span><span class="value">{{ response?.profile?.updatedAt || 'N/A' }}</span></div>
    </div>

    <div class="phone-section">
      <h3>Contact Details</h3>
      <p *ngIf="!getPhoneRows().length">No telephone numbers available.</p>
      <ul *ngIf="getPhoneRows().length">
        <li *ngFor="let phone of getPhoneRows()">
          {{ phone.number }} <span *ngIf="phone.lastUpdatedDate">({{ phone.lastUpdatedDate }})</span>
        </li>
      </ul>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
